import { BodyText, Button, Container, HeadingText } from '@paypalcorp/pp-react';
import React from 'react';
import { replaceGeoUrl } from '@common/replaceGeoUrl';
import serverData from '@client/utils/server-data';
import styles from './styles.css';

interface ErrorViewAction {
  text: string;
  href?: string;
  onClick?: React.MouseEventHandler<HTMLElement>;
}

/**
 * If the action has an href, it renders the Button as an <a>
 * instead of a <button>
 */
const TertiaryButton = ({ action }: { action: ErrorViewAction }) => (
  <Button
    tertiary
    as={action.href ? 'a' : undefined}
    href={action.href}
    onClick={action.onClick}
    className={styles.button}
  >
    {action.text}
  </Button>
);

export interface ErrorViewProps {
  title: string;
  subtitle?: string;
  action?: ErrorViewAction;
}

const ErrorView = ({ title, subtitle, action }: ErrorViewProps) => {
  return (
    <Container xxl>
      <div className={styles.container}>
        <img
          src={replaceGeoUrl(
            'https://www.paypalobjects.com/paypal-ui/pictograms/grayscale/svg/grayscale-2.svg',
            serverData?.geoAwareDomain
          )}
          alt="grayscale-icon"
          className={styles.img}
        />
        <HeadingText size="sm" className={styles.title}>
          {title}
        </HeadingText>
        {!!subtitle && <BodyText className={styles.subtitle}>{subtitle}</BodyText>}
        {!!action && <TertiaryButton action={action} />}
      </div>
    </Container>
  );
};

export default ErrorView;
